import { integer, object } from '@if/core/yup'
import { ControlledNumberField, useFormDialog } from '@if/mui'
import { ArrowLeftRight } from 'lucide-react'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import ReturnToCalendarAction, { RETURN_TO_CALENDAR, ToolResult } from './EditPayments-tool'

export interface MoveSelectedPaymentsSchemaType {
  nbOfDays: number
}

/** Shifts every payment in scope by the same number of days, forwards or backwards. */
export const useMoveSelectedPaymentsDialog = () => {
  const { t } = useTranslation()

  const schema = useMemo(
    () =>
      object({
        nbOfDays: integer().required().notOneOf([0], t('loan.payment.moveCalendarDialog.errors.zeroDayShift')),
      }),
    [t],
  )

  return useFormDialog<MoveSelectedPaymentsSchemaType, void, ToolResult<MoveSelectedPaymentsSchemaType>>({
    icon: ArrowLeftRight,
    title: t('loan.payment.moveCalendarDialog.title'),
    confirmLabel: t('common.confirm'),
    maxWidth: 'sm',
    fullWidth: true,
    schema,
    successMessage: false,
    additionalActions: (ctx) => <ReturnToCalendarAction onReturn={() => ctx.close(RETURN_TO_CALENDAR)} />,
    onSubmit: (data) => data,
    content: ({ form }) => (
      <ControlledNumberField
        control={form.control}
        name="nbOfDays"
        label={t('loan.payment.moveSelectedPayments.nbOfDays')}
        disableDecimals
        enableNegative
        autoFocus
      />
    ),
  })
}
